import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import swal from "sweetalert";
import PopupMenu from "./PopupMenu";
import CloseIcon from "@mui/icons-material/Close";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";

// SVG Cờ Việt Nam chuẩn
const vnFlagSvg = "https://cdn.creazilla.com/emojis/62210/vietnam-flag-emoji-clipart-lg.png";

const Header = ({ profileProp, hideHeader }) => {
    // Axios interceptors setup
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const navigate = useNavigate();
    const location = useLocation();

    const currentProductRef = useRef(null);
    const isPlayingRef = useRef(false);

    // 1. STATE CỦA HEADER CHUNG
    const [profile, setProfile] = useState(profileProp);
    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify")));
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const [isOpen, setIsOpen] = useState(false);
    const [menu, setMenu] = useState(null);
    const [time, setTime] = useState("");
    const [isLoading, setLoading] = useState(false);
    const [showBalance, setShowBalance] = useState(true);
    

    // 2. STATE VÀ LOGIC CHO POPUP AUTH (REGISTER KHI CÓ REF)
    const [showLoginPopup, setShowLoginPopup] = useState(false);
    const [showRegisterPopup, setShowRegisterPopup] = useState(false);
    const [affiliate, setAffiliate] = useState(null);
    const [errReg, setErrReg] = useState(null);

    const [showRegPassword, setShowRegPassword] = useState(false);
    const [showRegPasswordConfirm, setShowRegPasswordConfirm] = useState(false);
    const [showRegPayPwd, setShowRegPayPwd] = useState(false);

    const { register: regRegister, handleSubmit: handleRegisterSubmit, formState: { errors: errsReg }, setError: setErrRg, reset: resetRegister } = useForm();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const refParam = urlParams.get("ref");
        if (refParam) {
            setAffiliate(refParam);
            setShowRegisterPopup(true);
        } else if (localStorage.getItem("affiliate")) {
            setAffiliate(localStorage.getItem("affiliate"));
        }
    }, []);

    const onSubmitRegister = (data, e) => {
        e.preventDefault();
        const phoneNumberPattern = /^(0\d{9,10})$/;
        const regex = /^[a-zA-Z0-9]+$/;

        if (data.username.length < 6) return setErrRg("username", { message: "Tối thiểu 6 kí tự" });
        if (data.username.length > 12) return setErrRg("username", { message: "Tối đa 12 kí tự" });
        if (!regex.test(data.username)) return setErrRg("username", { message: "Không hợp lệ" });
        if (data.password.length < 6) return setErrRg("password", { message: "Tối thiểu 6 kí tự" });
        if (data.password !== data.ippassword) return setErrRg("ippassword", { message: "Mật khẩu không khớp" });
        if (!data.sdt || !phoneNumberPattern.test(data.sdt)) return setErrRg("sdt", { message: "SĐT không hợp lệ" });
        if (data.paypwd.length < 6) return setErrRg("paypwd", { message: "Tối thiểu 6 kí tự" });

        const formData = {
            username: data.username.toLowerCase(),
            password: data.password,
            code: affiliate || (data.code === "" ? "admin" : data.code),
            sdt: data.sdt,
            name: data.username,
            paypwd: data.paypwd
        };

        axios.post(`${process.env.REACT_APP_API_URL}/auth/register`, formData)
            .then(() => {
                swal("Thông báo", "Đăng ký thành công", "success").then(() => {
                    axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, {
                        username: data.username.toLowerCase(),
                        password: data.password
                    }).then((res) => {
                        localStorage.setItem("user", res.data.data);
                        window.location.reload();
                    });
                });
            })
            .catch((err) => setErrReg(err.response?.data?.message || "Đã có lỗi xảy ra!"));
    };

    // 3. LOGIC TỰ ĐỘNG CHUYỂN QUỸ VÀ IFRAME GAME
    const [playGame, setPlayGame] = useState(null);
    const [product, setProduct] = useState(null);
    const [gameList, setGameList] = useState([]);
    const [showGameList, setShowGameList] = useState(false);
    const [listTitle, setListTitle] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    
    // STATE: Lưu danh sách các mã game bị lỗi ảnh
    const [failedImages, setFailedImages] = useState({});

    useEffect(() => { isPlayingRef.current = !!playGame; }, [playGame]);
    useEffect(() => { currentProductRef.current = product; }, [product]);

    const backgroundWithdraw = async (prodType) => {
        if (!prodType) return;
        try {
            const resBal = await axios.post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: prodType });
            const currentBal = resBal.data?.data?.balance;
            if (currentBal >= 1) {
                await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                    product_type: prodType, type: 2, money: Math.floor(currentBal)
                });
                const resProfile = await axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`);
                setProfile(resProfile.data.data);
                localStorage.setItem("profile", JSON.stringify(resProfile.data.data));
            }
        } catch (e) {
            console.log("Rút tiền sảnh thất bại!", e);
        }
    };

    const handleForceExit = () => {
        if (isPlayingRef.current && currentProductRef.current) {
            const prodToWithdraw = currentProductRef.current;
            setPlayGame(null);
            setProduct(null);
            isPlayingRef.current = false;
            currentProductRef.current = null;
            document.body.classList.remove("header-game-playing");
            backgroundWithdraw(prodToWithdraw);
        }
    };

    useEffect(() => {
        const handleTabClose = () => {
            if (isPlayingRef.current && currentProductRef.current) {
                const token = localStorage.getItem("user");
                if (token) {
                    const prod = currentProductRef.current;
                    fetch(`${process.env.REACT_APP_API_URL}/casino/getbalance`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                        body: JSON.stringify({ product_type: prod }),
                        keepalive: true
                    }).then(res => res.json()).then(data => {
                        const bal = data?.data?.balance;
                        if (bal >= 1000) {
                            fetch(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                                body: JSON.stringify({ product_type: prod, type: 2, money: Math.floor(bal) }),
                                keepalive: true
                            }).catch(() => {});
                        }
                    }).catch(() => {});
                }
            }
        };
        window.addEventListener("beforeunload", handleTabClose);
        return () => window.removeEventListener("beforeunload", handleTabClose);
    }, []);

    useEffect(() => {
        handleForceExit();
    }, [location.pathname]);

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            setTime(now.toLocaleTimeString("vi-VN") + " " + now.toLocaleDateString("vi-VN"));
        }, 1000);

        if (localStorage.getItem("setting")) {
            setSetting(JSON.parse(localStorage.getItem("setting")));
        } else {
            axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => setSetting(res.data.data[0]));
        }

        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {}).then((res) => setNotify(res.data.data));

        const fetchProfileContinuous = () => {
            const token = localStorage.getItem("user");
            if (token) {
                axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`)
                    .then((res) => {
                        setProfile(res.data.data);
                        localStorage.setItem("profile", JSON.stringify(res.data.data));
                    }).catch(() => {});
            }
        };

        fetchProfileContinuous();
        const timer = setInterval(fetchProfileContinuous, 3000);

        return () => {
            clearInterval(interval);
            clearInterval(timer);
        };
    }, []);

    useEffect(() => { if(profileProp) setProfile(profileProp); }, [profileProp]);

    useEffect(() => {
        if (playGame) {
            document.body.classList.add("header-game-playing");
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            document.body.classList.remove("header-game-playing");
        }
        return () => {
            document.body.classList.remove("header-game-playing");
        }
    }, [playGame]);

    function isMobileDevice() {
        if (window.innerWidth < 800) return true;
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    const fetchGameList = (title, product_type, game_type) => {
        setListTitle(title); 
        setSearchQuery(""); 
        setLoading(true);
        setFailedImages({});
        
        axios.post(`${process.env.REACT_APP_API_URL}/casino/getgamelist`, { product_type, game_type })
            .then((res) => {
                if (res.data.data.length === 0) { 
                    swal("Thông báo", "Sảnh game bảo trì", "error"); 
                    setLoading(false); 
                } else { 
                    setGameList(res.data.data[0]); 
                    setShowGameList(true); 
                    setLoading(false); 
                }
            }).catch(() => { 
                swal("Thông báo", "Sảnh game bảo trì", "error"); 
                setLoading(false); 
            });
    };

    const launchGame = async (params) => {
        if (!localStorage.getItem("profile") || localStorage.getItem("profile") === "undefined") {
            setShowLoginPopup(true); return;
        }
        if (isLoading) return;
        
        handleForceExit();
        setLoading(true);

        try {
            const form = { ...params, platform: isMobileDevice() ? "html5" : "html5-desktop" };
            
            const resGame = await axios.post(`${process.env.REACT_APP_API_URL}/casino/launchgame`, form);
            
            if (resGame?.data?.data?.status !== 0) {
                setLoading(false); swal("Sảnh đang bảo trì", "Vui lòng chọn sảnh khác", "error"); return;
            }

            const gameUrl = resGame.data.data.game_url;
            setProduct(params.product_type);
            currentProductRef.current = params.product_type;
            setShowGameList(false);

            if (profile && profile.money >= 1000) {
                try {
                    await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                        product_type: params.product_type, type: 1, money: Math.floor(profile.money)
                    });
                } catch (transferErr) { console.log("Lỗi chuyển tiền vào:", transferErr); }
            }

            setPlayGame(gameUrl);
            setLoading(false);
        } catch (err) {
            setLoading(false);
            swal("Thất bại", err.response?.data?.message || "Đã có lỗi xảy ra", "error");
        }
    };

    const logOut = () => {
        handleForceExit();
        localStorage.clear();
        var now = new Date();
        now.setTime(now.getTime());
        document.cookie = "jwt=;Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        window.location.href = "/";
    };

    const getProfile = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            }).catch(() => localStorage.removeItem("user"));
    };

    const openPopup = (num) => { handleForceExit(); setMenu(num); setIsOpen(true); };
    const closePopup = () => setIsOpen(false);

    // MENU DATA ĐẦY ĐỦ BAO GỒM CẢ "TRÒ CHƠI"
    const menuData = [{
      id: "topnav-home",
      title: "TRANG CHỦ",
      to: "/home",
      icon: "https://i.ibb.co/2YhKjbhj/image.png",
      iconHover: "https://i.ibb.co/2YhKjbhj/image.png"
  }, {
      id: "topnav-sports",
      title: "THỂ THAO",
      to: "/sports",
      icon: "https://i.ibb.co/5Wp72FPF/anh1-2-removebg-preview.png",
      iconHover: "https://i.ibb.co/5Wp72FPF/anh1-2-removebg-preview.png",
      subMenu: [{
          title: "Saba Sports",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__sports-sb_1759848455387.webp",
          productType: "174",
          gameCode: "SB0001"
      }, {
          title: "CMD",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__sports-cmd_1759848499061.webp",
          productType: "104",
          gameCode: "CMD001"
      }, {
          title: "SBO",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__sports-sbo_1759848535503.webp",
          productType: "54",
          gameCode: "SBO041"
      }, {
          title: "United Gaming",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__sports-ug2_1759848561484.webp",
          productType: "151",
          gameCode: "UG2001"
      }, {
          title: "BTI",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__sports-bti_1759848658157.webp",
          productType: "142",
          gameCode: "FB0001"
      }]
  }, {
      id: "topnav-casino",
      title: "LIVE CASINO",
      to: "/casino",
      icon: "https://i.ibb.co/kgF0H0kv/image.png",
      iconHover: "https://i.ibb.co/kgF0H0kv/image.png",
      subMenu: [{
          title: "DG CASINO",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__live-DG_1681697470590.webp",
          productType: "27",
          gameCode: "DG0013"
      }, {
          title: "WM CASINO",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__live-WM_1681697554501.webp",
          productType: "118",
          gameCode: "WM0001"
      }, {
          title: "SEXY CASINO",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__live-SEX_1681697533566.webp",
          productType: "112",
          gameCode: "SEX001"
      }, {
          title: "AG CASINO",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__live-AB_1681697445434.webp",
          productType: "4",
          gameCode: "A00070"
      }, {
          title: "SA CASINO",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__live-SA_1681697543504.webp",
          productType: "28",
          gameCode: "SA0001"
      }, {
          title: "EVO CASINO",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__live-eg4_1725489231791.webp",
          productType: "86",
          gameCode: "EG0001"
      }]
  }, {
      id: "topnav-slots",
      title: "NỔ HŨ",
      to: "/slots",
      icon: "https://i.ibb.co/rKtqYmSx/image.png",
      iconHover: "https://i.ibb.co/rKtqYmSx/image.png",
      subMenu: [{
          title: "CQ9",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__rng-CQ9_1681697699702.webp",
          productType: "16",
          gameType: "RNG"
      }, {
          title: "PPLAY",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__rng-PP_1681697829296.webp",
          productType: "39",
          gameType: "RNG"
      }, {
          title: "JILI",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__rng-JL_1681697769343.webp",
          productType: "140",
          gameType: "RNG"
      }, {
          title: "JDB",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__rng-JDB_1681697758323.webp",
          productType: "55",
          gameType: "RNG"
      }, {
          title: "AG",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__RNG-AG_1756715241572.webp",
          productType: "4",
          gameType: "RNG"
      }, {
          title: "BBIN",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__RNG-BB_1755485410571.webp",
          productType: "79",
          gameType: "RNG"
      }, {
          title: "MG",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__rng-MG_1689589210494.webp",
          productType: "43",
          gameType: "RNG"
      }, {
          title: "PG",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__rng-PG_1681697808247.webp",
          productType: "98",
          gameType: "RNG"
      }]
  }, {
      id: "topnav-fish",
      title: "BẮN CÁ",
      to: "/fishing",
      icon: "https://i.ibb.co/2YNwCHbV/image.png",
      iconHover: "https://i.ibb.co/2YNwCHbV/image.png",
      subMenu: [{
          title: "JILI",
       img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__rng-JL_1681697769343.webp",
          productType: "140",
          gameType: "FISH"
      }, {
          title: "MG",
            img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__rng-MG_1689589210494.webp",
          productType: "43",
          gameType: "FISH"
      }, {
          title: "CQ9",
           img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__rng-CQ9_1681697699702.webp",
          productType: "16",
          gameType: "FISH"
      }, {
          title: "JDB",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__rng-JDB_1681697758323.webp",
          productType: "55",
          gameType: "FISH"
      }]
  }, {
      id: "topnav-poker",
      title: "GAME BÀI",
      to: "/pvp",
      icon: "https://i.ibb.co/MDshQfZ1/image.png",
      iconHover: "https://i.ibb.co/MDshQfZ1/image.png",
      subMenu: [{
          title: "V8 POKER",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__pvp-LCC_1681697635575.png",
          productType: "102",
          gameCode: "LCC001"
      }, {
          title: "KINGMAKER",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__pvp-KM_1681697617375.webp",
          productType: "121",
          gameCode: "KM0001"
      }]
  }, {
      id: "topnav-lottery",
      title: "XỔ SỐ",
      to: "/lottery",
      icon: "https://i.ibb.co/4ZXqJsbW/image.png",
      iconHover: "https://i.ibb.co/4ZXqJsbW/image.png",
      subMenu: [{
          title: "XS MIỀN BẮC",
          img: "https://i.ibb.co/nsy18NNG/image.png",
          navigateTo: "/lottery"
      }, {
          title: "XS MIỀN NAM",
          img: "https://i.ibb.co/7dLnZkGf/image.png",
          navigateTo: "/lottery"
      }, {
          title: "XS MIỀN TRUNG",
          img: "https://i.ibb.co/6RVv1zVz/image.png",
          navigateTo: "/lottery"
      }, {
          title: "XS NHANH 75S",
          img: "https://i.ibb.co/xSnPQpmS/image.png",
          navigateTo: "/lottery"
      }, {
          title: "XS NHANH 120S",
          img: "https://i.ibb.co/SDjGHMrh/image.png",
          navigateTo: "/lottery"
      }]
  }, {
      id: "topnav-number",
      title: "TRÒ CHƠI",
      to: "/sicbo",
      icon: "https://i.ibb.co/1fY2qHhH/gemini-svg-5-removebg-preview.png",
      iconHover: "https://i.ibb.co/1fY2qHhH/gemini-svg-5-removebg-preview.png",
      subMenu: [{
          title: "TÀI XỈU 45S",
          img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/number/auto_numbers.png",
          navigateTo: "/sicbo"
      }, {
          title: "TÀI XỈU 60S",
          img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/number/live_numbers.png",
          navigateTo: "/sicbo"
      }, {
          title: "XÓC ĐĨA 45S",
          img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/number/keno.png",
          navigateTo: "/sicbo"
      }, {
          title: "XÓC ĐĨA 60S",
          img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/number/keno_new.png",
          navigateTo: "/sicbo"
      }]
  }, {
      id: "topnav-cockfight",
      title: "ĐÁ GÀ",
      to: "/cockfighting",
      icon: `https://i.ibb.co/99HLwzj7/image.png`, 
      iconHover: `https://i.ibb.co/99HLwzj7/image.png` ,
      subMenu: [{
          title: "WS168",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__sports-ws168_1748531923790.png",
          productType: "202",
          gameCode: "WS1682"
      }, {
          title: "SV388",
          img: "https://images.7087053.com/prod-images/game_icon/sv3688/smallImage/gcs__sports-sv3_1748531911477.webp",
          productType: "132",
          gameCode: "SV3002"
      }]
  }, {
      id: "topnav-promo",
      title: "KHUYẾN MÃI",
      to: "/promotion",
      icon: "https://i.ibb.co/2YPKfJH7/image.png",
      iconHover: "https://i.ibb.co/2YPKfJH7/image.png"
  }];

    return (
        <>
            {isLoading && (
                <div className="loading" style={{ zIndex: 99999999 }}>
                    <div className="loader"></div>
                </div>
            )}

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800;900&display=swap');
                @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css');

                body.header-game-playing .main,
                body.header-game-playing .bg-esport,
                body.header-game-playing .sports-wrapper,
                body.header-game-playing .bg-fishing,
                body.header-game-playing .slot-page-wrapper,
                body.header-game-playing .pvp-page-wrapper,
                body.header-game-playing .content_lobby,
                body.header-game-playing .banner,
                body.header-game-playing footer { display: none !important; }

                .global-popup-overlay { position: fixed !important; top: 0 !important; left: 0 !important; width: 100vw !important; height: 100vh !important; background: rgba(0, 0, 0, 0.75) !important; z-index: 9999999 !important; display: flex !important; align-items: center !important; justify-content: center !important; padding: 15px; box-sizing: border-box; }
                @keyframes popInCenter { 0% { opacity: 0; transform: scale(0.8); } 100% { opacity: 1; transform: scale(1); } }
                
                /* ============================================================ */
                /* GIAO DIỆN HEADER MỚI (CHUẨN SV368)                           */
                /* ============================================================ */
                .custom-header { width: 100%; font-family: 'Montserrat', sans-serif; position: relative; z-index: 999; }
                .custom-container { max-width: 1200px; margin: 0 auto; padding: 0 15px; width: 100%; }

                /* --- TOP HEADER --- */
                .header-top { background: #111526; padding: 8px 0; border-bottom: 1px solid rgba(255,255,255,0.05); }
                .header-top-container { display: flex; justify-content: flex-end; align-items: center; position: relative; height: 36px; }

                .lang-select { position: absolute; left: 15px; display: flex; align-items: center; gap: 6px; color: #fff; font-size: 12px; cursor: pointer; }
                .lang-select img { width: 22px; height: 22px; border-radius: 50%; }

                .user-controls { display: flex; align-items: center; gap: 20px; }
                
                /* ĐÃ FIX LẠI FONT VÀ CSS CHO NÚT NẠP / RÚT TIỀN */
                .btn-nt { background: linear-gradient(to right, #00c6ff, #0072ff); color: #fff; font-weight: 800; border: none; padding: 8px 24px; border-radius: 30px; cursor: pointer; font-size: 13px; text-transform: uppercase; box-shadow: 0 4px 15px rgba(0, 114, 255, 0.4); transition: all 0.3s ease; letter-spacing: 0.5px; }
                .btn-nt:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(0, 114, 255, 0.6); }
                
                .btn-rt { background: linear-gradient(to right, #fceabb, #f8b500); color: #333; font-weight: 800; border: none; padding: 8px 24px; border-radius: 30px; cursor: pointer; font-size: 13px; text-transform: uppercase; box-shadow: 0 4px 15px rgba(248, 181, 0, 0.4); transition: all 0.3s ease; letter-spacing: 0.5px; }
                .btn-rt:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(248, 181, 0, 0.6); color: #000; }

                .user-info, .user-balance, .user-logout { display: flex; align-items: center; gap: 8px; color: #fff; font-size: 13px; font-weight: 600; cursor: pointer; transition: 0.2s; }
                .user-info i, .user-balance i { color: #00e5ff; font-size: 18px; }
                .user-logout i { color: #fff; font-size: 18px; }
                .user-info:hover, .user-balance:hover, .user-logout:hover { color: #00e5ff; }

                .login-form { display: flex; align-items: center; gap: 15px; }
                .btn-login { background: linear-gradient(180deg, #74e5ff 0%, #1bb5ff 100%); color: #000; border: none; height: 34px; padding: 0 25px; border-radius: 20px; font-weight: bold; cursor: pointer; font-size: 13px; text-transform: uppercase; transition: 0.2s; }
                .btn-login:hover { filter: brightness(1.1); box-shadow: 0 0 10px rgba(27, 181, 255, 0.5); }
                .btn-register { background: linear-gradient(180deg, #dfff60 0%, #88d400 100%); color: #000; display: flex; align-items: center; justify-content: center; height: 34px; padding: 0 25px; border-radius: 20px; font-weight: bold; font-size: 13px; text-transform: uppercase; cursor: pointer; transition: 0.2s; border: none; }
                .btn-register:hover { filter: brightness(1.1); box-shadow: 0 0 10px rgba(136, 212, 0, 0.5); }

                /* --- BOTTOM HEADER --- */
                .header-bottom { background: #232845; position: relative; }
                .header-bottom-container { display: flex; align-items: center; height: 75px; }
                .header-logo { margin-right: auto; }
                .header-logo img { height: 45px; }

                .navbars { height: 100%; }
                .navbar-list { display: flex; height: 100%; list-style: none; margin: 0; padding: 0; gap: 5px; }
                .nav-item { height: 100%; position: static; cursor: pointer; }
                .nav-item > a { 
                    display: flex; flex-direction: column; align-items: center; justify-content: center;
                    height: 100%; padding: 0 12px; text-decoration: none; color: #fff;
                    font-weight: 700; font-size: 12px; position: relative; transition: 0.2s; text-transform: uppercase;
                }
                .nav-item > a img { height: 26px; margin-bottom: 5px; }
                .nav-item > a::after {
                    content: ''; position: absolute; bottom: 0; left: 50%; transform: translateX(-50%);
                    width: 0; height: 4px; background: #00e5ff; transition: 0.3s; border-radius: 2px 2px 0 0;
                }
                .nav-item.active > a::after, .nav-item:hover > a::after, .nav-item.force-open > a::after { width: 100%; }
                .nav-item.active > a, .nav-item:hover > a, .nav-item.force-open > a { color: #00e5ff; }

                /* --- MEGA MENU FULL MÀN HÌNH --- */
                .sub-navbar-mega {
    display: none;
    position: absolute;
    padding: 29px 0;
    left: 0;
    right: 0;
    width: 100%;
    background: rgb(17 21 38 / 82%);
    padding: 413px 0;
    z-index: 1000;
    border-top: 1px solid rgba(0, 229, 255, 0.4);
    backdrop-filter: blur(8px);
}
                
                /* TRIGGER MỞ MEGA MENU (Hover hoặc Bị ép Force Open do Double Click) */
                .nav-item:hover .sub-navbar-mega, .nav-item.force-open .sub-navbar-mega { display: block !important; }
                
             .sub-navbar-flex {
    display: flex;
    justify-content: center;
    gap: 53px;
    flex-wrap: wrap;
    margin: -375px auto;
}

                .sub-navbar-item-box { display: flex; flex-direction: column; align-items: center; gap: 10px; text-decoration: none; transition: 0.2s; }
                .sub-navbar-item-box:hover { transform: translateY(-5px); }
                .sub-navbar-item-box .img-wrapper {
                    width: 120px; height: 120px;
                }
                .sub-navbar-item-box .img-wrapper img { width: 100%; height: 100%; border-radius: 50%; object-fit: cover; }
                .sub-navbar-item-box span { color: #fff; font-size: 13px; font-weight: 700; }
                .btn-dat-cuoc {
                    background: linear-gradient(0deg,#192c64 2.08%,#05c3ff 98.61%); color: #fff;
                    padding: 6px 20px; border-radius: 20px; border: none; font-size: 12px; font-weight: bold; cursor: pointer;
                    box-shadow: 0 4px 8px rgba(0,0,0,0.3); transition: 0.2s;
                }
                .sub-navbar-item-box:hover .btn-dat-cuoc { background: linear-gradient(180deg, #4fc3f7 0%, #0277bd 100%); }

                /* ============================================================ */
                /* GIAO DIỆN GAME LIST GRID KHI CLICK (TÌM KIẾM TRONG SẢNH)     */
                /* ============================================================ */
                .in-page-gamelist-wrapper { background-color: #1a1c38; border-bottom: 2px solid #2f3569; padding: 20px 0; animation: fadeInDown 0.3s ease-out forwards; }
                .gamelist-header-inline { display: grid; grid-template-columns: 1fr auto 1fr; align-items: center; margin-bottom: 25px; }
                .gamelist-header-inline h3 { margin: 0; color: #00e5ff; font-size: 18px; font-weight: 800; text-transform: uppercase; }
                
                .gl-search-box-inline { position: relative; width: 100%; min-width: 350px; justify-self: center; }
                .gl-search-box-inline input { width: 100%; padding: 12px 15px 12px 40px; border-radius: 30px; border: 1px solid #2f3569; background: rgba(255,255,255,0.1); color: #fff; outline: none; font-size: 14px; font-family: 'Montserrat', sans-serif; box-sizing: border-box; }
                .gl-search-box-inline input::placeholder { color: #aaa; }
                .gl-search-box-inline i { position: absolute; left: 15px; top: 50%; transform: translateY(-50%); color: #00e5ff; }
                
                .btn-close-wrapper { justify-self: end; }
                .btn-close-inline { background: #e53935; color: #fff; border: none; border-radius: 50%; width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: 0.2s; }
                .btn-close-inline:hover { background: #c62828; transform: scale(1.1); }
                
                .games-grid-container { display: grid; grid-template-columns: repeat(auto-fill, minmax(130px, 1fr)); gap: 15px; max-height: 550px; overflow-y: auto; padding: 5px; }
                .games-grid-container::-webkit-scrollbar { width: 6px; }
                .games-grid-container::-webkit-scrollbar-track { background: transparent; }
                .games-grid-container::-webkit-scrollbar-thumb { background: #00e5ff; border-radius: 10px; }
                
                .new-gameslot-item.grid-item { background: #2f3569; border-radius: 12px; overflow: hidden; cursor: pointer; border: 1px solid #3a417a; transition: transform 0.2s; display: flex; flex-direction: column; }
                .new-gameslot-item.grid-item:hover { transform: translateY(-5px); box-shadow: 0 6px 15px rgba(0, 229, 255, 0.4); }
                
                .slot-img-wrapper { width: 100%; aspect-ratio: 1; background: #1a1c38; position: relative; }
                .slot-img-wrapper img { width: 100%; height: 100%; object-fit: cover; display: block; }
                .new-gameslot-name { background: #2f3569; color: #fff; text-align: center; padding: 10px 5px; font-size: 13px; font-weight: bold; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

                /* IFRAME CHUẨN */
                .embedded-game-container { position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 9999999; display: flex; flex-direction: column; background: #000; margin: 0; padding: 0; }
                .embedded-game-header { height: 45px; background: #1a1a1a; display: flex; align-items: center; justify-content: flex-start; padding: 0 15px; border-bottom: 2px solid #b71c1c; }
                .btn-exit-game { display: flex; align-items: center; background: #d32f2f; color: #fff; border: none; padding: 6px 15px; border-radius: 4px; cursor: pointer; font-weight: bold; font-size: 14px; transition: 0.2s; }
                .game-iframe { width: 100%; flex: 1; border: none; background: #000; }

                /* POPUP ĐĂNG KÝ (Giữ nguyên) */
                .register-popup-box { background: url('https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/register_bg.png') no-repeat center center; background-size: cover; background-color: rgba(220, 235, 245, 0.9); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); width: 100%; max-width: 800px; border-radius: 20px; position: relative; padding: 25px 40px 30px; box-shadow: 0 10px 40px rgba(0,0,0,0.4); animation: popInCenter 0.3s ease-out forwards; max-height: 95vh; overflow-y: auto; border: 1px solid rgba(255, 255, 255, 0.4); }
                .reg-close-btn { position: absolute; right: 30px; top: 15px; cursor: pointer; color: #555; line-height: 0; transition: 0.2s; }
                .reg-header { text-align: center; margin-bottom: 20px; }
                .reg-logo-img { height: 60px; object-fit: contain; margin-bottom: 10px; }
                .reg-title { margin: 0; font-size: 22px; font-weight: bold; color: #333; }
                .reg-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px 30px; }
                .reg-input-wrap label { display: block; font-size: 13px; color: #3870a3; font-weight: bold; margin-bottom: 6px; }
                .reg-input-inner { position: relative; display: flex; align-items: center; background: rgba(255, 255, 255, 0.6); border-radius: 30px; height: 42px; border: 1px solid rgba(255,255,255,0.6); box-sizing: border-box; }
                .reg-input-inner input { flex: 1; height: 100%; border: none; background: transparent; font-size: 13px; color: #333; outline: none; padding: 0 20px; }
                .auth-icon-right { position: absolute; right: 26px; top: 30%; transform: translateY(-50%); color: #3870a3; cursor: pointer; line-height: 0; }
                .auth-error-msg { color: #d32f2f; font-size: 11px; margin-top: 5px; padding-left: 15px; font-style: italic; }
                .reg-terms { grid-column: 1 / -1; display: flex; align-items: center; gap: 8px; font-size: 13px; color: #333; margin-top: 10px; padding-left: 5px;}
                .reg-btn-wrapper { grid-column: 1 / -1; text-align: center; margin-top: 10px; }
                .btn-reg-submit { background: #e33b54; color: #fff; border: none; border-radius: 30px; padding: 12px 40px; font-size: 16px; font-weight: bold; cursor: pointer; box-shadow: 0 4px 15px rgba(227, 59, 84, 0.4); text-transform: uppercase; min-width: 200px; }
                
                @media screen and (max-width: 900px) {
                    .header-top-container { flex-direction: column; gap: 10px; height: auto; padding: 10px 0; }
                    .lang-select { position: relative; left: 0; }
                    .header-bottom-container { flex-direction: column; gap: 10px; height: auto; padding: 10px 0; }
                    .navbar-list { flex-wrap: wrap; justify-content: center; }
                    .sub-navbar-mega { position: static; display: none; }
                    .gamelist-header-inline { display: flex; flex-direction: column; gap: 15px; position: relative; }
                    .btn-close-wrapper { position: absolute; right: 0; top: 0; }
                    .gl-search-box-inline { min-width: 100%; }
                }
            `}</style>

            {/* Chỉ hiển thị Header nếu không bật Game (ẩn sạch sẽ nhường view cho màn hình iframe phía trên) */}
            {(!playGame && !hideHeader) && (
                <header className="custom-header">
                    
                    {/* TOP HEADER */}
                    <div className="header-top">
                        <div className="custom-container header-top-container">
                            <div className="lang-select">
                                <img src={vnFlagSvg} alt="VN" />
                                <span>Tiếng việt <i className="fa fa-caret-down"></i></span>
                            </div>

                            <div className="auth-section">
                                {profile ? (
                                    <div className="user-controls">
                                        <button className="btn-nt" onClick={() => { handleForceExit(); openPopup(2); }}>Nạp Tiền</button>
                                        <button className="btn-rt" onClick={() => { handleForceExit(); openPopup(3); }}>Rút Tiền</button>
                                        
                                        <div className="user-info" onClick={() => { handleForceExit(); openPopup(1); }}>
                                            <i className="fa fa-user-circle"></i>
                                            <span>{profile.username}(VIP1)</span>
                                        </div>

                                        <div className="user-balance" onClick={() => setShowBalance(!showBalance)}>
                                            <i className="fa fa-wallet"></i>
                                            <span>{showBalance ? profile.money.toLocaleString("vi-VN") : "***"}</span>
                                        </div>

                                        <div className="user-logout" onClick={logOut}>
                                            <i className="fa fa-power-off"></i>
                                            <span>Đăng Xuất</span>
                                        </div>
                                    </div>
                                ) : (
                                    // BỎ INPUT ĐĂNG NHẬP, CHỈ CÒN LẠI BUTTON LINK ĐẾN ĐĂNG NHẬP / ĐĂNG KÝ
                                    <div className="login-form">
                                        <button className="btn-login" onClick={() => navigate("/login")}>Đăng Nhập</button>
                                        <button className="btn-register" onClick={() => navigate("/register")}>Đăng ký</button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* BOTTOM HEADER */}
                    <div className="header-bottom">
                        <div className="custom-container header-bottom-container">
                            <div className="header-logo">
                                <Link to="/" onClick={handleForceExit}>
                                    <img alt="Logo" src={require("../../image/logo.png")} />
                                </Link>
                            </div>

                            <nav className="navbars">
                                <ul className="navbar-list">
                                    {menuData.map((item, index) => (
                                        <li 
    key={index} 
    id={item.id} 
    className={`nav-item ${location.pathname === item.to ? "active" : ""}`}
>
                                            <Link to={item.to} onClick={handleForceExit}>
                                                <img src={item.icon} alt={item.title} />
                                                <span>{item.title}</span>
                                            </Link>

                                            {/* MEGA MENU FULL MÀN HÌNH CHUẨN SV368 */}
                                            {item.subMenu && (
                                                <div className="sub-navbar-mega">
                                                    <div className="custom-container sub-navbar-flex">
                                                        {item.subMenu.map((sub, idx) => (
                                                            <a href="#!" key={idx} className="sub-navbar-item-box" onClick={(e) => {
                                                                e.preventDefault(); handleForceExit();
                                                                if (sub.gameType) fetchGameList(sub.title, sub.productType, sub.gameType);
                                                                else if (sub.productType && sub.gameCode) launchGame({ product_type: sub.productType, game_code: sub.gameCode });
                                                                else if (sub.navigateTo) navigate(sub.navigateTo);
                                                            }}>
                                                                {/* Ảnh Tròn */}
                                                                <div className="img-wrapper">
                                                                    <img src={sub.img} alt={sub.title} />
                                                                </div>
                                                                <span>{sub.title}</span>
                                                                <button className="btn-dat-cuoc">Đặt cược</button>
                                                            </a>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        </div>

                        {/* HIỂN THỊ DANH SÁCH GAME KHI TÌM KIẾM TRONG SẢNH */}
                        {showGameList && gameList && (
                            <div className="in-page-gamelist-wrapper">
                                <div className="custom-container">
                                    <div className="gamelist-header-inline">
                                        <h3>{listTitle}</h3>
                                        <div className="gl-search-box-inline">
                                            <i className="fa fa-search"></i>
                                            <input type="text" placeholder="Tìm kiếm game..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                                        </div>
                                        <div className="btn-close-wrapper">
                                            <button className="btn-close-inline" onClick={() => setShowGameList(false)}>
                                                <CloseIcon sx={{ fontSize: "16px" }} />
                                            </button>
                                        </div>
                                    </div>
                                    
                                    <div className="games-grid-container">
                                        {gameList
                                            .filter(item => 
                                                item.gameName.toLowerCase().includes(searchQuery.toLowerCase()) && 
                                                !failedImages[item.tcgGameCode]
                                            ).length > 0 ? (
                                                gameList
                                                .filter(item => 
                                                    item.gameName.toLowerCase().includes(searchQuery.toLowerCase()) && 
                                                    !failedImages[item.tcgGameCode]
                                                )
                                                .map((item, index) => (
                                                    <div className="new-gameslot-item grid-item" key={index} onClick={() => launchGame({ product_type: item.productType, game_code: item.tcgGameCode })}>
                                                        <div className="slot-img-wrapper">
                                                            <img 
                                                                src={`https://images.21947392.com/TCG_GAME_ICONS/${item.productCode}/VI/${item.tcgGameCode}.png`} 
                                                                onError={() => {
                                                                    setFailedImages(prev => ({ ...prev, [item.tcgGameCode]: true }));
                                                                }} 
                                                                alt={item.gameName} 
                                                            />
                                                        </div>
                                                        <div className="new-gameslot-name">{item.gameName}</div>
                                                    </div>
                                                ))
                                        ) : (
                                            <div style={{ color: '#00e5ff', fontSize: '15px', fontStyle: 'italic', gridColumn: '1 / -1', textAlign: 'center', padding: '20px 0' }}>
                                                Không tìm thấy game phù hợp!
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </header>
            )}

            {/* KHUNG IFRAME GAME HIỂN THỊ NẰM GỌN GÀNG MÀ KHÔNG ÉP F11 */}
            {playGame && (
                <div className="embedded-game-container">
                    <div className="embedded-game-header">
                        <button className="btn-exit-game" onClick={handleForceExit}>
                            <KeyboardArrowLeftOutlinedIcon style={{ fontSize: "20px" }}/>
                            <span>THOÁT GAME</span>
                        </button>
                    </div>
                    <iframe src={playGame} className="game-iframe" title="In-Web Game" allowFullScreen />
                </div>
            )}

            {/* POPUP ĐĂNG KÝ (GIỮ NGUYÊN DO ĐƯỢC GỌI TỪ NƠI KHÁC VÀ REDIRECT TỪ REF) */}
            {showRegisterPopup && (
                <div className="global-popup-overlay" onClick={(e) => { if(e.target === e.currentTarget) setShowRegisterPopup(false); }}>
                    <div className="register-popup-box">
                        <div className="reg-close-btn" onClick={() => setShowRegisterPopup(false)}><CloseIcon sx={{ fontSize: "16px" }} /></div>
                        <div className="reg-header">
                            <img className="reg-logo-img" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/logo.png" alt="Logo" />
                            <h2 className="reg-title">Đăng ký ngay</h2>
                        </div>
                        <form onSubmit={handleRegisterSubmit(onSubmitRegister)}>
                            {errReg && <p style={{ color: 'red', textAlign: 'center', fontSize: '14px', marginBottom: '15px' }}>{errReg}</p>}
                            <div className="reg-grid">
                                <div className="reg-col">
                                    <div className="reg-input-wrap">
                                        <label><i className="fa fa-star"></i> Tên tài khoản</label>
                                        <div className="reg-input-inner">
                                            <input type="text" {...regRegister("username")} placeholder="Tên tài khoản từ 6-20 Kí Tự..." />
                                        </div>
                                        {errsReg.username && <p className="auth-error-msg">{errsReg.username.message}</p>}
                                    </div>
                                    <div className="reg-input-wrap" style={{marginTop: "15px"}}>
                                        <label><i className="fa fa-star"></i> Xác nhận mật khẩu</label>
                                        <div className="reg-input-inner">
                                            <input type={showRegPasswordConfirm ? "text" : "password"} {...regRegister("ippassword")} placeholder="Không để trống" />
                                            <div className="auth-icon-right" onClick={() => setShowRegPasswordConfirm(!showRegPasswordConfirm)}>
                                                {showRegPasswordConfirm ? <Visibility sx={{ fontSize: "20px" }} /> : <VisibilityOff sx={{ fontSize: "20px" }} />}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="reg-input-wrap" style={{marginTop: "15px"}}>
                                        <label><i className="fa fa-star"></i> Số điện thoại</label>
                                        <div className="reg-input-inner"><input type="tel" {...regRegister("sdt")} placeholder="Nhập số điện thoại hợp lệ" /></div>
                                    </div>
                                </div>
                                <div className="reg-col">
                                    <div className="reg-input-wrap">
                                        <label><i className="fa fa-star"></i> Mật khẩu</label>
                                        <div className="reg-input-inner">
                                            <input type={showRegPassword ? "text" : "password"} {...regRegister("password")} placeholder="Hơn 8 ký tự" />
                                            <div className="auth-icon-right" onClick={() => setShowRegPassword(!showRegPassword)}>
                                                {showRegPassword ? <Visibility sx={{ fontSize: "20px" }} /> : <VisibilityOff sx={{ fontSize: "20px" }} />}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="reg-input-wrap" style={{marginTop: "15px"}}>
                                        <label><i className="fa fa-star"></i> Mật khẩu rút tiền</label>
                                        <div className="reg-input-inner">
                                            <input type={showRegPayPwd ? "text" : "password"} {...regRegister("paypwd")} placeholder="Tối thiểu 6 ký tự" />
                                            <div className="auth-icon-right" onClick={() => setShowRegPayPwd(!showRegPayPwd)}>
                                                {showRegPayPwd ? <Visibility sx={{ fontSize: "20px" }} /> : <VisibilityOff sx={{ fontSize: "20px" }} />}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="reg-input-wrap" style={{marginTop: "15px"}}>
                                        <label><i className="fa fa-star"></i> Mã giới thiệu</label>
                                        <div className="reg-input-inner"><input type="text" {...regRegister("code")} placeholder="Mã mời" defaultValue={affiliate || ""} readOnly={!!affiliate} /></div>
                                    </div>
                                </div>
                                <div className="reg-terms">
                                    <input type="checkbox" id="agree_terms" required defaultChecked />
                                    <label htmlFor="agree_terms" style={{margin: 0, fontWeight: "normal", color: "#333", fontSize: "13px"}}>Đã đủ 18 tuổi</label>
                                </div>
                                <div className="reg-btn-wrapper"><button type="submit" className="btn-reg-submit">ĐĂNG KÝ</button></div>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            <PopupMenu profile={profile} isOpen={isOpen} isClose={closePopup} menuActive={menu} getProfile={getProfile} />
        </>
    );
};

export default Header;